import React, { useEffect, useState } from 'react';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'; 
import { useSelector } from 'react-redux';
import defaultImage from '../assest/DAWACO_Icon.png'; 
import { useNavigate } from 'react-router-dom';
import ROLE from '../common/role';

const AdminAllRefunds = () => {
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const user = useSelector(state => state?.user?.user);
  const [showConfirm, setShowConfirm] = useState(false);
  const [action, setAction] = useState('');
  const [loadingAction, setLoadingAction] = useState(false);
  const [refundId, setRefundId] = useState('');
  const [selectedProducts, setSelectedProducts] = useState({});   
  const [quantities, setQuantities] = useState({});
  const [prices, setPrices] = useState({});
  const initialSelectedProducts = {};
  const initialQuantities = {}; 

  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const fetchRefundRequests = async () => {
    try {
        setLoading(true);

          
      const body = {
        user: user,
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : ''
      };

        const response = await fetch(SummaryApi.allRefundRequests.url, {
          method: SummaryApi.allRefundRequests.method,
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          }, 
          body: JSON.stringify(body),
        });
        
        const responseData = await response.json();
        const refundData = responseData.data || [];

      refundData.forEach(refund => {
        const productIds = refund.productDetails?.map(product => product.productId) || [];
        
        initialSelectedProducts[refund._id] = productIds;
        prices[refund._id] = refund.totalPrice
        initialQuantities[refund._id] = [];
        refund.productDetails?.forEach(product => {
            initialQuantities[refund._id].push({
                productId: product.productId,
                quantity: product.quantity
            });
        });
    });

      setData(refundData);
      setSelectedProducts(initialSelectedProducts);
      setQuantities(initialQuantities);
    } catch (error) {
    } finally {
      setLoading(false); 
    }
  };

  
  useEffect(() => {
    fetchRefundRequests();
  }, [startDate,endDate]);

  useEffect(() => {
    setLoadingPage(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoadingPage(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.ADMIN) {
        navigate('/');
        setLoadingPage(false);
      } 
      else {
        if(user?.type === "Admin"){
            navigate('/admin-panel/all-users');
            setLoadingPage(false);
        }
        else{
            setLoadingPage(false);
            clearTimeout(loadingTimeout);
        }
       
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  if (loadingPage) {
    return (
        <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
    );
}


  const handleCheckboxChange = (refundId, productId, isChecked, unitPrice, quantity) => {
   
    setSelectedProducts(prev => {
      const refundSelection = prev[refundId] || [];
      const updatedSelection = isChecked
        ? [...refundSelection, productId]
        : refundSelection.filter(id => id !== productId); 
  
      return {
        ...prev,
        [refundId]: updatedSelection,
      };
    });
  
    setPrices(prevPrices => {
      const currentPrice = prevPrices[refundId] || 0; 
      const priceChange = unitPrice * quantity; 
  
      if (isChecked) {
        
        const newPrice = currentPrice + priceChange;
        return {
          ...prevPrices,
          [refundId]: parseFloat(newPrice.toFixed(2)), 
        };
      } else {
       
        const newPrice = Math.max(0, currentPrice - priceChange);
        return {
          ...prevPrices,
          [refundId]: parseFloat(newPrice.toFixed(2)), 
        };
      }
    });
  };
  


  const handleQuantityChange = (refundId, productId, change,unitPrice) => {
    setQuantities(prevQuantities => {
   
      const refundProducts = prevQuantities[refundId];

      const updatedProducts = refundProducts.map(product => {
        if (product.productId === productId) {
          return {
            ...product,
            quantity: Math.max(1, product.quantity + change),
          };
        }
        return product;
      });
  
      return {
        ...prevQuantities,
        [refundId]: updatedProducts,
      };
    });
  
    setPrices(prevPrices => {
    
      const currentPrice = prevPrices[refundId] || 0;
      const newPrice = parseFloat((currentPrice + unitPrice).toFixed(2));
  
      return {
        ...prevPrices,
        [refundId]: newPrice,
      };
    });
  };
  
  
  

  const handleClick = (actionType, refundId) => {
    setAction(actionType);
    setShowConfirm(true);
    setRefundId(refundId);
  };

  const handleConfirm = async (confirmed) => {
    if (confirmed) {
      setLoadingAction(true); 
      if (action === 'accept') {
        try {
          await fetch(SummaryApi.acceptRefundRequest.url, {
            method: SummaryApi.acceptRefundRequest.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            }, 
            body: JSON.stringify({
              refundId: refundId,
              selectedProducts: selectedProducts[refundId],
              quantities : quantities[refundId],
              price : prices[refundId]
            }),
          });
        } catch (error) {
        } finally {
          setShowConfirm(false);
          setLoadingAction(false);
          window.location.reload();
        }
      } else if (action === 'reject') {
        try {
          await fetch(SummaryApi.rejectRefundRequest.url, {
            method: SummaryApi.rejectRefundRequest.method,
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            }, 
            body: JSON.stringify({
              refundId: refundId,
            }),
          });
        } catch (error) {
        } finally {
          setShowConfirm(false);
          setLoadingAction(false);
          window.location.reload();
        }
      }
    } else {
      setShowConfirm(false);
    }
  };

  return (
    <div >

                      {/* Date Filter Section */}
<div className="flex justify-end items-start mb-4">
  <div className="text-right">
    <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها جميع طلبات الاسترجاع </h2>

    <div className="flex gap-6 justify-end">
      {/* Start Date */}
      <div>
        <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
          تاريخ البداية
        </label>
        <input
          type="date"
          id="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>

      {/* End Date */}
      <div>
        <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
          تاريخ النهاية
        </label>
        <input
          type="date"
          id="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
        />
      </div>
    </div>
  </div>
</div>
      
      {loading ? (
        <div className="flex justify-center items-center h-64">
          <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
        </div>
      ) : (

      

        data.length === 0 ? (
          <p className="text-center text-gray-500">لا يوجد طلبات استرجاع</p>
        ) : (
          
          
          
          <div className='p-4 w-full'>
            {data.map((item, index) => (
              <div key={item._id || index} className='my-4'>
                <p className='font-medium text-lg'>{moment(item.createdAt).format('LL')}</p>
                <div className='border rounded-lg p-4 bg-gray-50 shadow-md'>
                  <div className='flex flex-col lg:flex-row justify-between'>
                    <div className='flex flex-col gap-4'>
                      <> 
                        <span style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#333333' }}>
                          طلب استرجاع من الطلب # {item?.refundFromOrderNumber}
                        </span>
                        {item?.refundSalesManName!=="" &&<span style={{ fontWeight: 'bold', fontSize: '1.25rem', color: '#333333' }}>
                           تم بواسطة مندوب  ({item?.refundSalesManName}) 
                        </span>}
                        {item?.refundSalesManName==="" &&<span style={{ fontWeight: 'bold', fontSize: '1.2rem', color: '#333333' }}>
                          تم بواسطة الصيدلية 
                        </span>}
                      </>
                      {item.productDetails?.map((product, index) => (
                        <div key={product.productId + index} className='flex gap-4 bg-white p-4 rounded-lg shadow-md border border-gray-200'>
                          <input
                            type="checkbox"
                            className='mr-2'
                            onChange={(e) => handleCheckboxChange(item._id, product.productId, e.target.checked,product.unitPrice,quantities?.[item._id]?.find(p => p.productId === product.productId)?.quantity)}
                            checked={selectedProducts[item._id]?.includes(product.productId)} // Checkbox checked if product is selected
                          />
                          <img
                            src={product?.productImage?.[0] || defaultImage } // Handle missing image
                            className='w-24 h-20 bg-gray-200 object-cover rounded-md'
                            alt={product?.productName || 'Product Image'}
                          />
                          <div className='flex-1'>
                            <div className='font-medium text-lg text-gray-800'>
                              {product?.productName}
                            </div>
                            <div className='flex items-center gap-4 mt-2'>
                              <div className='text-lg text-blue-800'>
                                {displayINRCurrency(product?.unitPrice)}
                              </div>
                              <p className='text-gray-700'>الكمية: {product?.quantity}</p>
                            </div>
                            {selectedProducts[item?._id]?.includes(product?.productId) && (
                              <div className="flex items-center mt-2">
                                <button
                                   className="flex items-center justify-center w-8 h-8 border border-blue-800 rounded-full hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                  onClick={() => handleQuantityChange(item?._id,product?.productId, -1,(-1*product?.unitPrice))}
                                  disabled={quantities?.[item?._id]?.find(p => p?.productId === product?.productId)?.quantity === 1} 
                                >
                                  -
                                </button>
                                <span className="mx-2">{quantities?.[item._id]?.find(p => p?.productId === product?.productId)?.quantity || 0 }</span>
                                <button
                                   className="flex items-center justify-center w-8 h-8 border border-blue-800 rounded-full hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed"
                                  onClick={() => handleQuantityChange(item?._id,product?.productId, 1,product?.unitPrice)}
                                  disabled={quantities?.[item?._id]?.find(p => p?.productId === product?.productId)?.quantity === product?.quantity}
                                >
                                  +
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className='font-semibold ml-auto w-fit lg:text-lg'>
                      <div className='flex items-center mb-3'>
                        <span className='block mr-2 text-gray-600'>السعر الاجمالى :</span>
                        <span className='text-xl font-bold text-blue-800'>
                          {displayINRCurrency(item?.totalPrice || 0)}
                        </span>
                      </div>
                      <div className='flex items-center mb-3'>
                        <span className='block mr-2 text-gray-600'>سعر المنتجات المحددة :</span>
                        <span className='text-xl font-bold text-blue-800'>
                          {displayINRCurrency(prices[item?._id])}
                        </span>
                      </div>

                      <div className='mt-4 border-t pt-2'>
                        <div className='bg-gray-100 p-4 rounded-lg shadow-sm'>
                          <h3 className='text-lg font-semibold mb-2 border-b pb-2 text-gray-800'>معلومات المستخدم</h3>
                          <p className='mb-1 text-gray-700'><strong>الاسم:</strong> {item?.userName}</p>
                          <p className='mb-1 text-gray-700'><strong>البريد الالكترونى:</strong> {item?.email}</p>
                          <p className='text-gray-700'><strong>عنوان التوصيل:</strong> {item?.userShippingAddress}</p>
                          <p className='text-gray-700'><strong>رقم الهاتف المحمول:</strong> {item?.userMobileNumber}</p>
                        </div>
                      </div>

                      {/* Buttons for Accept and Reject */}
                      <div className='mt-4 flex border-t pt-2 space-x-4 ml-10'>
                        <button
                          className='bg-red-600 hover:bg-red-500 text-white px-4 py-2 rounded-lg'
                          onClick={() => handleClick('reject', item?._id)}
                        >
                          رفض الطلب
                        </button>
                        <button
                          className={`bg-green-600 hover:bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg ${!selectedProducts[item?._id] || selectedProducts[item?._id]?.length === 0? 'opacity-50 cursor-not-allowed' : ''}`}
                          onClick={() => handleClick('accept', item?._id)}
                          disabled={!selectedProducts[item?._id] || selectedProducts[item?._id]?.length === 0} // Disable if no product is selected
                        >
                          قبول الطلب
                        </button>
                      </div>

                 {/* Confirmation Modal */}
{showConfirm && (
    <div className="fixed inset-0 flex items-center justify-center z-50">
        {/* Backdrop */}
        <div className="absolute inset-0 bg-black bg-opacity-10"></div>

        {/* Modal */}
        <div className="bg-white p-6 rounded shadow-lg relative max-w-md mx-auto">
            {/* Centered title */}
            <h3 className="text-lg font-semibold mb-4 text-center">
                تأكيد {action === 'accept' ? 'قبول' : 'رفض'} الطلب
            </h3>

            {/* Show loading icon or the confirmation message */}
            {loadingAction ? (
                <div className="flex justify-center items-center">
                    <AiOutlineLoading3Quarters className="animate-spin text-4xl text-blue-500" />
                </div>
            ) : (
                <>
                    {/* Confirmation message */}
                    <p className="text-lg mb-4 text-center">
                        هل أنت متأكد أنك تريد {action === 'accept' ? 'قبول' : 'رفض'} هذا الطلب؟
                    </p>

                    {/* Buttons */}
                    <div className="mt-4 flex justify-center gap-4">
                        <button
                            className="bg-red-500 text-white px-4 py-2 rounded-lg"
                            onClick={() => handleConfirm(true)}
                        >
                            نعم
                        </button>
                        <button
                            className="bg-gray-300 px-4 py-2 rounded-lg"
                            onClick={() => handleConfirm(false)}
                        >
                            لا
                        </button>
                    </div>
                </>
            )}
        </div>
    </div>
)}


                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default AdminAllRefunds;
